// NotificationContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import CustomNotifications from './custom-notification';

const NotificationContext = createContext();

export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = (message, color = 'info') => {
    setNotification({ message, color });
    setTimeout(() => {
      hideNotification();
    }, 10000); // Disappear after 10 seconds (10000 milliseconds)
  };

  const hideNotification = () => {
    setNotification(null);
  };

  return (
    <NotificationContext.Provider
      value={{ showNotification, hideNotification }}
    >
      {children}
      {notification && (
        <CustomNotifications
          message={notification.message}
          color={notification.color}
          hide={hideNotification}
        />
      )}
    </NotificationContext.Provider>
  );
};
